/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'
import router from '@/router'
import axios from '../../http/axios/index.js'

export default {
  // JWT
  loginJWT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .login(
          payload.userDetails.email,
          payload.userDetails.password,
          payload.userDetails.captcha,
          payload.userDetails.twofa,
          payload.userDetails.cfcaptcha,
        )
        .then(response => {
          // If there's user data in response
          if (response.data.data) {
            // Set accessToken
            localStorage.setItem('accessToken', response.data.data.token)
            // Set accessToken
            localStorage.setItem(
              'refreshToken',
              response.data.data.refreshToken,
            )

            // Update user details
            commit('UPDATE_USER_INFO', response.data.data, { root: true })

            // Set bearer token in axios
            axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.data.token}`

            // Navigate User to homepage
            router.push(router.currentRoute.query.to || '/')
            resolve(response)
          } else {
            reject({
              message: response.data,
              status: response.data.status,
            })
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  registerUserJWT({ commit }, payload) {
    const {
      firstname,
      lastname,
      email,
      password,
      phone,
      confirmPassword,
      captcha,
      cfcaptcha,
    } = payload.userDetails

    return new Promise((resolve, reject) => {
      jwt
        .registerUser(firstname, lastname, email, phone, password, captcha, cfcaptcha)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loginOAuth({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .loginOAuth(
          payload.email,
          payload.token,
          payload.sub,
          payload.type,
        )
        .then(response => {
          // If there's user data in response
          if (response.data.data) {
            // Set accessToken
            localStorage.setItem('accessToken', response.data.data.token)
            // Set accessToken
            localStorage.setItem(
              'refreshToken',
              response.data.data.refreshToken,
            )

            // Update user details
            commit('UPDATE_USER_INFO', response.data.data, { root: true })

            // Set bearer token in axios
            axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.data.token}`

            // Navigate User to homepage
            router.push(router.currentRoute.query.to || '/')
            resolve(response)
          } else {
            reject({
              message: response.data,
              status: response.data.status,
            })
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchAccessToken() {
    return new Promise((resolve, reject) => {
      jwt
        .refreshToken()
        .then(response => {
          if (response.data.error) {
            reject(response.data.error);
            return;
          }
          localStorage.setItem('accessToken', response.data.data.token)
          localStorage.setItem('refreshToken', response.data.data.refresh_token)
          // Set new bearer token in axios
          axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.data.token}`
          
          // // Set accessToken
          // localStorage.setItem('refreshToken', response.data.data.refreshToken)

          resolve(response.data.data.token)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
